<template>
  <div>
    <div class="hero tradingsoftware-bg">
      <div class="inner">
        <h1>{{$t('tradingSoftwareDevPage.text1')}}</h1>
        <h5 class="subtitle" v-html="$t('tradingSoftwareDevPage.text2')"></h5>
        <div class="hero-btn-container" @click="goContact">
          <BtnPrimary text="Contact us now" />
        </div>
      </div>
    </div>

    <section class="section3">
      <div class="section-inner">
        <h2 class="section-title">{{$t('tradingSoftwareDevPage.text3')}}</h2>
        <div class="spacer"></div>
        <div class="col4-grid center">
          <div class="col4-grid-item">
            <div class="why-nums">2021</div>
            <h5>{{$t('tradingSoftwareDevPage.text4')}}</h5>
          </div>
          <div class="col4-grid-item">
            <div class="why-nums">9</div>
            <h5>{{$t('tradingSoftwareDevPage.text5')}}</h5>
          </div>
          <div class="col4-grid-item">
            <div class="why-nums">6</div>
            <h5>{{$t('tradingSoftwareDevPage.text6')}}</h5>
          </div>
          <div class="col4-grid-item">
            <div class="why-nums">17</div>
            <h5>{{$t('tradingSoftwareDevPage.text7')}}</h5>
          </div>
        </div>
				<div class="spacer"></div>
        <div class="col4-grid center">
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/tradingsoft-icon1.svg" alt="" /></div>
            <h5>{{$t('tradingSoftwareDevPage.text8')}}</h5>
            <p>{{$t('tradingSoftwareDevPage.text9')}}</p>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/tradingsoft-icon2.svg" alt="" /></div>
            <h5>{{$t('tradingSoftwareDevPage.text10')}}</h5>
            <p>{{$t('tradingSoftwareDevPage.text11')}}</p>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/tradingsoft-icon3.svg" alt="" /></div>
            <h5>{{$t('tradingSoftwareDevPage.text12')}}</h5>
            <p>{{$t('tradingSoftwareDevPage.text13')}}</p>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/tradingsoft-icon4.svg" alt="" /></div>
            <h5>{{$t('tradingSoftwareDevPage.text14')}}</h5>
            <p>{{$t('tradingSoftwareDevPage.text15')}}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section3 dark">
      <div class="section-inner">
        <div class="article-col2-container">
          <div class="text-col">
            <h2 class="section-title">{{$t('tradingSoftwareDevPage.text16')}}</h2>
            <p>{{$t('tradingSoftwareDevPage.text17')}}</p>
          </div>
          <div class="img-col">
            <img src="@/assets/images/tradingsoft-image1.png" alt="" />
          </div>
        </div>
      </div>
    </section>
    <section class="section3 light-gray">
      <div class="section-inner">
        <h2 class="section-title">{{$t('tradingSoftwareDevPage.text18')}}</h2>
        <p>{{$t('tradingSoftwareDevPage.text19')}}</p>
        <div class="spacer"></div>
        <div class="col6-grid">
          <div class="col6-grid-item">
            <div class="step">1</div>
            <div class="col-title">{{$t('tradingSoftwareDevPage.text20')}}</div>
            <div class="col-para">{{$t('tradingSoftwareDevPage.text21')}}</div>
          </div>
          <div class="col6-grid-item">
            <div class="step">2</div>
            <div class="col-title">{{$t('tradingSoftwareDevPage.text22')}}</div>
            <div class="col-para">{{$t('tradingSoftwareDevPage.text23')}}</div>
          </div>
          <div class="col6-grid-item">
            <div class="step">3</div>
            <div class="col-title">{{$t('tradingSoftwareDevPage.text24')}}</div>
            <div class="col-para">{{$t('tradingSoftwareDevPage.text25')}}</div>
          </div>
          <div class="col6-grid-item">
            <div class="step">4</div>
            <div class="col-title">{{$t('tradingSoftwareDevPage.text26')}}</div>
            <div class="col-para">{{$t('tradingSoftwareDevPage.text27')}}</div>
          </div>
          <div class="col6-grid-item">
            <div class="step">5</div>
            <div class="col-title">{{$t('tradingSoftwareDevPage.text28')}}</div>
            <div class="col-para">{{$t('tradingSoftwareDevPage.text29')}}</div>
          </div>
          <div class="col6-grid-item">
            <div class="step">6</div>
            <div class="col-title">{{$t('tradingSoftwareDevPage.text30')}}</div>
            <div class="col-para">{{$t('tradingSoftwareDevPage.text31')}}</div>
          </div>
        </div>
      </div>
    </section>
    <section class="section3">
      <div class="section-inner">
        <h2 class="section-title">Technologies we use</h2>
        <div class="spacer"></div>
        <div class="col5-grid">
          <div class="col5-grid-item">
            <img src="@/assets/images/tech-image1.png" alt="" />
            <div class="tech-name">Spring Boot</div>
          </div>
          <div class="col5-grid-item">
            <img src="@/assets/images/tech-image2.png" alt="" />
            <div class="tech-name">Vue.js</div>
          </div>
          <div class="col5-grid-item">
            <img src="@/assets/images/tech-image3.png" alt="" />
            <div class="tech-name">Java</div>
          </div>
          <div class="col5-grid-item">
            <img src="@/assets/images/tech-image4.png" alt="" />
            <div class="tech-name">Delphi</div>
          </div>
          <div class="col5-grid-item">
            <img src="@/assets/images/tech-image5.png" alt="" />
            <div class="tech-name">Redis</div>
          </div>
          <div class="col5-grid-item">
            <img src="@/assets/images/tech-image6.png" alt="" />
            <div class="tech-name">PostgreSQL</div>
          </div>
          <div class="col5-grid-item">
            <img src="@/assets/images/tech-image7.png" alt="" />
            <div class="tech-name">MariaDB</div>
          </div>
          <div class="col5-grid-item">
            <img src="@/assets/images/tech-image8.png" alt="" />
            <div class="tech-name">MongoDB</div>
          </div>
          <div class="col5-grid-item">
            <img src="@/assets/images/tech-image9.png" alt="" />
            <div class="tech-name">MySQL</div>
          </div>
          <div class="col5-grid-item">
            <img src="@/assets/images/tech-image10.png" alt="" />
            <div class="tech-name">Docker</div>
          </div>
        </div>
      </div>
    </section>
    <section class="section3 orange">
      <div class="section-inner">
        <h2 class="section-title">Let Us Help You With Your Business Challenges</h2>
        <router-link to="contact" class="contact-us"><BtnPrimary text="Contact us" inverse /></router-link>
      </div>
    </section>
    <section class="section3">
      <div class="section-inner">
        <h2 class="section-title">Companies We Work With</h2>
        <div class="spacer"></div>
        <div class="col4-grid center">
          <div class="col4-grid-item">
            <div><img class="company-image" src="@/assets/images/company-image1.png" alt="" /></div>
          </div>
          <div class="col4-grid-item">
            <div><img class="company-image" src="@/assets/images/company-image2.png" alt="" /></div>
          </div>
          <div class="col4-grid-item">
            <div><img class="company-image" src="@/assets/images/company-image3.png" alt="" /></div>
          </div>
          <div class="col4-grid-item">
            <div><img class="company-image" src="@/assets/images/company-image4.png" alt="" /></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BtnPrimary from '@/components/BtnPrimary.vue';
export default {
  name: 'TradingSoftwareDevPage',
  components: { BtnPrimary },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    goContact() {
      this.$router.push('contact')
    }
  },
};
</script>

<style lang="scss" scoped></style>
